export default __webpack_public_path__ + "static/media/ic_usdt_40.6edf6fb0.svg";